<script>
    import "./diveDeeper.css";
    let diveImage = "./images/dive-deeper-img.png";
</script>

<div class="dive-deeper-wrap flex flex-wrap column-direction flex-text-center items-center">
    <img src={diveImage} alt="dive deeper image">
    <h2>DIVE DEEPER INTO UNIX DAO</h2>
    <p>UniX Gaming is a DAO on the Ethereum network for play to earn economies.</p>
    <div class="button-wrapper flex flex-wrap">
        <a href="#" class="dive-btn" target="_blank">Buy on Uniswap</a>
        <a href="#" class="dive-btn" target="_blank">Buy on Pancakeswap</a>
        <a href="#" class="dive-btn" target="_blank">Buy on gate.io</a>
    </div>
</div>